'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
var tslib_1 = require("tslib");
var adapter_1 = require("../adapter");
var transport_1 = require("../transport");
var Translations = /** @class */ (function () {
    function Translations() {
    }
    /**
     * Fetch translations from cdn
     *
     * @param {string} locale
     * @param {boolean} [isProd=false]
     * @returns {Promise<ITranslationItem[]>}
     * @memberof Translations
     */
    Translations.prototype.fetch = function (locale, isProd) {
        if (isProd === void 0) { isProd = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var content;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.translations.fetch(this.getTranslationsUrl(locale, isProd))];
                    case 1:
                        content = _a.sent();
                        return [2 /*return*/, JSON.parse(content)];
                }
            });
        });
    };
    /**
     * Formats and returns the translation url per locale and env.
     * @param {string} locale
     * @param {boolean} isProd
     * @returns string
     */
    Translations.prototype.getTranslationsUrl = function (locale, isProd) {
        var file = "" + locale + (isProd ? '' : '-staging') + ".json";
        return transport_1.transport.getCDNUrl() + "/translations/" + file;
    };
    return Translations;
}());
exports.translations = new Translations();
